window.CurrentSort = "BestMatch";
window.CurrentPage = 1;

//---------------------------- PHP URL LIST BASED ON SORT ----------------------------

window.BestMatchUrl = 'best-match';
window.LowestPriceUrl = 'lowest-price';
window.HotDealsUrl = 'special-deals';
window.AlmostFullUrl = 'almost-full';

window.SortedAccommodationData = [];
window.FinalFilteredAccommodationData = [];
window.SearchPaginationData = null;

window.ScrollSentinel = null;

// ======================== PREPARE SEARCH SECTION INFO ==============================

window.SearchSectionPrepareInfo = function()
{
    window.ScrollSentinel = document.getElementById("scrollSentinel");

    window.PrepareSliderValue();
    window.PrepareUISearchInfoText();
    window.GetSearchOutput();
}

window.PrepareUISearchInfoText = function()
{
    let SortByHeaderText = document.getElementById("SortByHeaderText");
    if(SortByHeaderText != null)
        SortByHeaderText.innerHTML = window["SortByTxt" + window.CurrentCountryID] + ":";

    let BestMatchSortText = document.getElementById("BestMatchSortText"); // --- Best Match ---
    if(BestMatchSortText != null)
        BestMatchSortText.innerHTML = window["BestMatchTxt" + window.CurrentCountryID];

    let BestMatchSortAbvText = document.getElementById("BestMatchSortAbvText");
    if(BestMatchSortAbvText != null)
        BestMatchSortAbvText.innerHTML = window["BestMatchAbvTxt" + window.CurrentCountryID];

    
    let LowestPriceSortText = document.getElementById("LowestPriceSortText"); // --- Lowest Price ---
    if(LowestPriceSortText != null)
        LowestPriceSortText.innerHTML = window["LowestPriceTxt" + window.CurrentCountryID];
    
    let LowestPriceSortAbvText = document.getElementById("LowestPriceSortAbvText");
    if(LowestPriceSortAbvText != null)
        LowestPriceSortAbvText.innerHTML = window["LowestPriceAbvTxt" + window.CurrentCountryID];

    let HotDealsSortText = document.getElementById("HotDealsSortText"); // --- Hot Deals ---
    if(HotDealsSortText != null)
        HotDealsSortText.innerHTML = window["HotDealsTxt" + window.CurrentCountryID];

    let HotDealsSortAbvText = document.getElementById("HotDealsSortAbvText");
    if(HotDealsSortAbvText != null)
        HotDealsSortAbvText.innerHTML = window["HotDealsAbvTxt" + window.CurrentCountryID];

    let AlmostFullSortText = document.getElementById("AlmostFullSortText"); // --- Almost Full ---
    if(AlmostFullSortText != null)
        AlmostFullSortText.innerHTML = window["AlmostFullTxt" + window.CurrentCountryID];

    let AlmostFullSortAbvText = document.getElementById("AlmostFullSortAbvText");
    if(AlmostFullSortAbvText != null)
        AlmostFullSortAbvText.innerHTML = window["AlmostFullAbvTxt" + window.CurrentCountryID];


    let FiltersHeaderText = document.getElementById("FiltersHeaderText");
    if(FiltersHeaderText != null)
        FiltersHeaderText.innerHTML = window["FilterTxt" + window.CurrentCountryID];

    let BudgetPerNightHeaderText = document.getElementById("BudgetPerNightHeaderText");
    if(BudgetPerNightHeaderText != null)
        BudgetPerNightHeaderText.innerHTML = window["BudgetPerNightTxt" + window.CurrentCountryID];

    let MinHeaderText = document.getElementById("MinHeaderText");
    if(MinHeaderText != null)
        MinHeaderText.innerHTML = window["MinHeaderTxt" + window.CurrentCountryID];

    let MaxHeaderText = document.getElementById("MaxHeaderText");
    if(MaxHeaderText != null)
        MaxHeaderText.innerHTML = window["MaxHeaderTxt" + window.CurrentCountryID];

    let CategoryHeaderText = document.getElementById("CategoryHeaderText");
    if(CategoryHeaderText != null)
        CategoryHeaderText.innerHTML = window["CategoryHeaderTxt" + window.CurrentCountryID];
}

window.GetSearchOutput = function()
{
    let CurrentUrl = new URL(window.location.href);
    let param = new URLSearchParams(CurrentUrl.search.slice(1));

    window.SlugInfo = window.location.pathname.split("/").pop().split(".")[0];

    if(window.SlugInfo != null)
    {
        if(CurrentUrl.searchParams.get("search") == null)
        {
            window.SearchInfo = window.SlugInfo.replace(/-/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
        }
    }
    else
    {

        return
    }

    // ------------------------- SET TOP SEARCH INFO --------------------------------

    window.SetUpTopDateQuotaSearch(true);

    //-------------------------- SET THE POPULAR FILTER --------------------------

    document.getElementById("FilterLeftHeadersPopularFilter").innerHTML = window["PopularFilterInHeaderTxt" + window.CurrentCountryID] + " " + window.CapitalizeEveryLetter(window.SearchInfo);

    //-------------------------- GET HOW MANY Accommodation ------------------------------

    if(window.SearchInfo == null || window.SearchInfo == "")
    {
        document.getElementById("NoFeaturedPropertyFoundContainer").style.display = "";
        document.getElementById("NoHotelAvailableText").innerHTML = window["NoAccommodationAvailableTxt" + window.CurrentCountryID];
        document.getElementById("NoHotelAvailableMessageText").innerHTML = window["PleaseChangeFilterTxt" + window.CurrentCountryID];

        document.getElementById("SearchResultPanelContainer").innerHTML = "";
        document.getElementById("SearchResultPanelContainer").style.display = "none";

        document.getElementById("PopularFilterMainContainer").style.display = "none";
        document.getElementById("AreaFilterMainContainer").style.display = "none";
        document.getElementById("CategoryFilterMainContainer").style.display = "none";
    }
    else
    {
        //------------------------- SET ALL INPUT FIELDS VALUE -----------------------------

        let CheckInInfoToPadStart = window.CheckInInfo.split("-")
        let CheckInInfoCombined = CheckInInfoToPadStart[0] + "-" + CheckInInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckInInfoToPadStart[2].toString().padStart(2, '0');

        let CheckOutInfoToPadStart = window.CheckOutInfo.split("-")
        let CheckOutInfoCombined = CheckOutInfoToPadStart[0] + "-" + CheckOutInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckOutInfoToPadStart[2].toString().padStart(2, '0');

        // var LatestUrl = "searchresult.php?search=" + window.SearchInfo + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + window.RoomNumberInfo + "&slug=" + window.SlugInfo;
        var LatestUrl = "/search/" + window.CurrentCountryID + "/" +  window.SlugInfo  + ".html?search=" + window.SearchInfo + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + window.RoomNumberInfo;
        if(CurrentUrl.searchParams.has('area'))
        {
            LatestUrl = LatestUrl + "&area=" + CurrentUrl.searchParams.get("area");
        }

        if (typeof (window.history.replaceState) != "undefined")
        {
            var obj =
            {
                Url: LatestUrl
            };
            window.history.replaceState(obj, obj.Title, obj.Url);
        }

        // =========================== LOAD TRENDING ACCOMMODATION ON BOTTOM ==================================================

        let WhereToInstantiateAll = document.getElementById("MainContentSectionToInsantiate");
        let TrendingAccommodationBottomURL = "/hotels/search/" + window.SlugInfo + "/popular?checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&rooms=" + window.RoomNumberInfo + "&min_price=" + window.SliderMin.value + "&max_price=" + window.SliderMax.value;
        let TrendingAccHeaderText = window["TrendingAccOnTxt" + window.CurrentCountryID] + " " + window.CapitalizeEveryLetter(window.SearchInfo);

        window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, TrendingAccommodationBottomURL, "TrendingAcc", TrendingAccHeaderText);
    }
}

window.LoadAccommodationBasedOnSort = function()
{
    // Prepare URL Based On Filter --------------------------------------------------------------------
    let LoadAccommodationURL = "/v2/hotels/search/" + window.SlugInfo + "/" + window[window.CurrentSort+"Url"] + "?checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&rooms=" + window.RoomNumberInfo + "&min_price=" + window.SliderMin.value + "&max_price=" + window.SliderMax.value + "&page=" + window.CurrentPage + "&limit=" + window.limitPanelPerPage;
    LoadAccommodationURL = window.AddFilterInfoToSort(LoadAccommodationURL);

    // Prepare Loading --------------------------------------------------------------------
    let LoadingPanelEarly = [];
    let IsAllowContinue = true;
    for(let i = 0; i < window.limitPanelPerPage; i++)
    {
        LoadingPanelEarly.push(window.InstantiateLoadingHotelPanel(document.getElementById("SearchResultPanelContainer")));
    }

    // Start Load the Info --------------------------------------------------------------------

    //console.log("Sort Based on " + window.CurrentSort + " ________________")
    //console.log(LoadAccommodationURL);

    window.CallApiAxios({
        method: "GET",
        url: LoadAccommodationURL
    }).then(res =>
    {
        //console.log(res);
        // Delete Early Loading Panel ---------------------------------
        for(let i = 0; i < LoadingPanelEarly.length; i++)
            LoadingPanelEarly[i].remove();
        
        if(res.status == 200)
        {
            //console.log("result" , res);
            let CurrentLoadedData = res.data.data;
            window.SortedAccommodationData = CurrentLoadedData;
            // CurrentLoadedData.forEach(ThisData =>
            // {
            //     window.SortedAccommodationData.push(ThisData);
            // });
            window.SearchPaginationData = res.data.pagination;

            //console.log(window.SortedAccommodationData);
            //console.log(window.SearchPaginationData);

            // window.GetMaxSliderValue();

            // Check If At Least One of Them Exist Or Not --------------------------------------
            if(window.CurrentPage == 1)
            {
                let HowManyNotExist = [];

                for(let i = 0; i < CurrentLoadedData.length; i++)
                {
                    if(CurrentLoadedData[i].availability_ratio == 0 || CurrentLoadedData[i].status_available == "No")
                    {
                        HowManyNotExist.push(CurrentLoadedData[i]);
                    }
                }

                if(HowManyNotExist.length == CurrentLoadedData.length)
                {
                    IsAllowContinue = false;
                }
            }
            
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            if(IsAllowContinue == false || window.SortedAccommodationData.length == 0)
            {
                window.SetSearchResultToNotFound();
            }
            else
            {
                window.ApplyFilter();
                document.getElementById("PopularFilterMainContainer").style.display = "";
                document.getElementById("AreaFilterMainContainer").style.display = "";
                document.getElementById("CategoryFilterMainContainer").style.display = "";
            }
        }
    })
    .catch(err =>
    {
        //console.error(err);
        window.SetSearchResultToNotFound();
    });

    return
    fetch(LoadAccommodationURL)
    .then(res =>
    {
        return res.json().then(data =>
        ({
            status: res.status,
            data: data
        }));
    })
    .then(result =>
    {
        // Delete Early Loading Panel ---------------------------------
        for(let i = 0; i < LoadingPanelEarly.length; i++)
            LoadingPanelEarly[i].remove();
        
        if(result.status == 200)
        {
            //console.log("result" , result);
            let CurrentLoadedData = result.data.data;
            window.SortedAccommodationData = CurrentLoadedData;
            // CurrentLoadedData.forEach(ThisData =>
            // {
            //     window.SortedAccommodationData.push(ThisData);
            // });
            window.SearchPaginationData = result.data.pagination;

            //console.log(window.SortedAccommodationData);
            //console.log(window.SearchPaginationData);

            // window.GetMaxSliderValue();

            // Check If At Least One of Them Exist Or Not --------------------------------------
            if(window.CurrentPage == 1)
            {
                let HowManyNotExist = [];

                for(let i = 0; i < CurrentLoadedData.length; i++)
                {
                    if(CurrentLoadedData[i].availability_ratio == 0 || CurrentLoadedData[i].status_available == "No")
                    {
                        HowManyNotExist.push(CurrentLoadedData[i]);
                    }
                }

                if(HowManyNotExist.length == CurrentLoadedData.length)
                {
                    IsAllowContinue = false;
                }
            }
            
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            if(IsAllowContinue == false || window.SortedAccommodationData.length == 0)
            {
                window.SetSearchResultToNotFound();
            }
            else
            {
                window.ApplyFilter();
                document.getElementById("PopularFilterMainContainer").style.display = "";
                document.getElementById("AreaFilterMainContainer").style.display = "";
                document.getElementById("CategoryFilterMainContainer").style.display = "";
            }
        }
    })
    .catch(function (error)
    {
        //console.log(error);
        window.SetSearchResultToNotFound();
    });
}

// =================================================== SET SEARCH TO NOT FOUND ================================================

window.SetSearchResultToNotFound = function()
{
    window.searchobserver.disconnect();

    document.getElementById("NoFeaturedPropertyFoundContainer").style.display = "";
    document.getElementById("NoHotelAvailableText").innerHTML = window["NoAccommodationAvailableTxt" + window.CurrentCountryID];
    document.getElementById("NoHotelAvailableMessageText").innerHTML = window["NoAccommodationAvailableTxt" + window.CurrentCountryID];

    document.getElementById("SearchResultPanelContainer").innerHTML = "";
    document.getElementById("SearchResultPanelContainer").style.display = "none";

    document.getElementById("PopularFilterMainContainer").style.display = "none";
    document.getElementById("AreaFilterMainContainer").style.display = "none";
    document.getElementById("CategoryFilterMainContainer").style.display = "none";
}


//==================================================== SCRIPT RELATED TO FILTER ===================================================

window.AddFilterInfoToSort = function(CurrentURL)
{
    // City Region ----------------------

    let CityRegionCheckBox = document.getElementsByClassName("AreaFilterCheckBox");

    for (let i = 0; i < CityRegionCheckBox.length; i++)
    {
        if(CityRegionCheckBox[i].checked == true)
        {
            CurrentURL = CurrentURL + "&city_region_slug[]=" + CityRegionCheckBox[i].value;
        }
    }

    // Category ------------------------

    let CategoryFilterCheckBox = document.getElementsByClassName("CategoryFilterCheckBox");
    for (let i = 0; i < CategoryFilterCheckBox.length; i++)
    {
        if(CategoryFilterCheckBox[i].checked == true)
        {
            CurrentURL = CurrentURL + "&category_id[]=" + CategoryFilterCheckBox[i].value;
        }
    }

    // Benefits ------------------------

    let PopularFilterCheckBox = document.getElementsByClassName("PopularFilterCheckBox");
    for (let i = 0; i < PopularFilterCheckBox.length; i++)
    {
        if(PopularFilterCheckBox[i].checked == true)
        {
            CurrentURL = CurrentURL + "&benefit_id[]=" + PopularFilterCheckBox[i].value;
        }
    }


    return CurrentURL;
}

window.ApplyFilter = function()
{
    let ThisSortedJSON = window.SortedAccommodationData;

    // ================================ SET INACTIVE ONE BELLOW ============================

    // ThisSortedJSON.sort((a, b) =>
    // {
    //     if (a.min_price === null && b.min_price !== null) return 1;
    //     if (a.min_price !== null && b.min_price === null) return -1;
    //     return a.value - b.value;
    // });

    //=================================== PRICE RANGE ===================================

    // let BudgetFilterData = [];

    // for(let i = 0; i < ThisSortedJSON.length; i++)
    // {
    //     if((ThisSortedJSON[i].price_after_disc == null && ThisSortedJSON[i].price_after_disc == null) || (ThisSortedJSON[i].price_after_disc >= window.SliderMin.value &&
    //         ThisSortedJSON[i].price_after_disc <= window.SliderMax.value &&
    //         ThisSortedJSON[i].price_after_disc != null))
    //     {
    //         BudgetFilterData.push(ThisSortedJSON[i]);
    //     }
    // }
    window.FinalFilteredAccommodationData = ThisSortedJSON;

    if(window.FinalFilteredAccommodationData.length <= 0)
    {
        document.getElementById("NoFeaturedPropertyFoundContainer").style.display = "";
        document.getElementById("NoHotelAvailableText").innerHTML = window["SorryNoAccFoundTxt" + window.CurrentCountryID];
        document.getElementById("NoHotelAvailableMessageText").innerHTML = window["AdjustDateOrFiltersTxt" + window.CurrentCountryID];

        document.getElementById("SearchResultPanelContainer").innerHTML = "";
        document.getElementById("SearchResultPanelContainer").style.display = "none";
    }
    else
    {
        document.getElementById("NoFeaturedPropertyFoundContainer").style.display = "none";
        document.getElementById("SearchResultPanelContainer").style.display = "";
        // document.getElementById("SearchResultPanelContainer").innerHTML = "";
    }

    window.InstantiateOrRemoveHotelPanel();
}

// ======================= INSTANTIATE SEARCH ROOM HOTEL PANEL =============================

window.InstantiateOrRemoveHotelPanel = function()
{
    let WhereToInstantiate = document.getElementById("SearchResultPanelContainer");

    // let HowManyImagesToBeCalculated = 0;

    // =========================== Instantiated Accommodation Panel ===========================

    for(let i = 0; i < window.FinalFilteredAccommodationData.length; i++)
    {
        // Loading Panel ------------------------------------------------------------

        let ThisLoadingPanel = window.InstantiateLoadingHotelPanel(WhereToInstantiate);
        let ThisAccAvailable = true;
        if(window.FinalFilteredAccommodationData[i].pick_room == null || window.FinalFilteredAccommodationData[i].status_available == "No")
            ThisAccAvailable = false;

        // Room Hotel Panel --------------------------------------------------------

        let RoomHotelPanel = document.createElement("div");
        RoomHotelPanel.className = "RoomHotelPanel";
        RoomHotelPanel.style.display = "none";
        WhereToInstantiate.append(RoomHotelPanel);

        let RoomHotelWrapper = document.createElement("div");
        RoomHotelWrapper.className = "RoomHotelWrapper";
        RoomHotelPanel.append(RoomHotelWrapper);

        let RoomHotelImageInsidePanel = document.createElement("div"); // Acc Photo -----------------------
        RoomHotelImageInsidePanel.className = "RoomHotelImageInsidePanel";
        RoomHotelWrapper.append(RoomHotelImageInsidePanel);

        let FunctionToCallAfterLoaded = function()
        {
            ThisLoadingPanel.remove();
            RoomHotelPanel.style.display = "";
        }

        if (window.innerWidth < 768 && window.FinalFilteredAccommodationData[i].photos.length > 0) // If mobile only 1 Image Instantiated
            window.FinalFilteredAccommodationData[i].photos.length = 1;
            // HowManyImagesToBeCalculated = 1;

        window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(window.FinalFilteredAccommodationData[i].photos, "hotel_photo", "/Assets/images/NoImage.jpeg", RoomHotelImageInsidePanel, { quality: 70}, RoomHotelPanel, ()=>FunctionToCallAfterLoaded());
        

        // Description ---------------------------------------------

        let RoomHotelImageRightSectionInSeparatorsidePanel = document.createElement("div");
        RoomHotelImageRightSectionInSeparatorsidePanel.className = "RoomHotelImageRightSectionInSeparatorsidePanel";
        RoomHotelWrapper.append(RoomHotelImageRightSectionInSeparatorsidePanel);

        let RoomHotelPanelInfoLeftWrapper = document.createElement("div");
        RoomHotelPanelInfoLeftWrapper.className = "RoomHotelPanelInfoLeftWrapper";
        RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoLeftWrapper);

        let RoomHotelNameInsidePanel = document.createElement("p"); // Acc Name -----------------------
        RoomHotelNameInsidePanel.className = "RoomHotelNameInsidePanel InterBoldTextFont";
        RoomHotelNameInsidePanel.innerHTML = window.FinalFilteredAccommodationData[i].hotel_name;
        RoomHotelPanelInfoLeftWrapper.append(RoomHotelNameInsidePanel);

        let RoomLocationContainerInsidePanel = document.createElement("div");
        RoomLocationContainerInsidePanel.className = "RoomLocationContainerInsidePanel";
        RoomLocationContainerInsidePanel.style = "width: 100%; margin-left: 0; margin-right: 0; margin-top: 0;";
        RoomHotelPanelInfoLeftWrapper.append(RoomLocationContainerInsidePanel);

        let LocationIconInsidePanel = document.createElement("img"); // Acc Location -----------------------
        LocationIconInsidePanel.className = "LocationIconInsidePanel";
        LocationIconInsidePanel.style = "margin-left: 0; margin-right: 0;";
        LocationIconInsidePanel.src = "/Assets/images/ButtonIcon/location-icon.svg";
        RoomLocationContainerInsidePanel.append(LocationIconInsidePanel);

        let RoomLocationTextInsidePanel = document.createElement("p");
        RoomLocationTextInsidePanel.className = "RoomLocationTextInsidePanel InterMediumTextFont";
        RoomLocationTextInsidePanel.innerHTML = window.FinalFilteredAccommodationData[i].city_region + ", " + window.FinalFilteredAccommodationData[i].province;
        RoomLocationContainerInsidePanel.append(RoomLocationTextInsidePanel);

        if(window.FinalFilteredAccommodationData[i].link_gmaps != null)
        {
            RoomLocationTextInsidePanel.innerHTML = RoomLocationTextInsidePanel.innerHTML + " - ";

            let SeeMapTextInsidePanel = document.createElement("a");
            SeeMapTextInsidePanel.className = "SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText";
            SeeMapTextInsidePanel.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
            SeeMapTextInsidePanel.target = "_blank";
            SeeMapTextInsidePanel.rel = "noopener noreferrer";
            SeeMapTextInsidePanel.style.zIndex = 1;
            SeeMapTextInsidePanel.href = window.FinalFilteredAccommodationData[i].link_gmaps;
            RoomLocationContainerInsidePanel.append(SeeMapTextInsidePanel);
        }

        // Benefits ---------------------------------------------

        let GetBenefitsThisAcc = [];

        for(let j = 0; j < window.FinalFilteredAccommodationData[i].rooms.length; j++)
        {
            for(let k = 0; k < window.FinalFilteredAccommodationData[i].rooms[j].length; k++)
            {
                if(GetBenefitsThisAcc.includes(window.FinalFilteredAccommodationData[i].rooms[j].benefits[k]) == false)
                {
                    GetBenefitsThisAcc.push(window.FinalFilteredAccommodationData[i].rooms[j].benefits[k]);
                }
            }
        }

        if(GetBenefitsThisAcc != [])
        {
            let RoomHotelBenefitsInsidePanel = document.createElement("div");
            RoomHotelBenefitsInsidePanel.className = "RoomHotelBenefitsInsidePanel";
            RoomHotelPanelInfoLeftWrapper.append(RoomHotelBenefitsInsidePanel);

            let RoomHotelBenefitsSwiper = document.createElement("div");
            RoomHotelBenefitsSwiper.className = "swiper-wrapper";
            RoomHotelBenefitsInsidePanel.append(RoomHotelBenefitsSwiper);

            for(let j = 0; j < GetBenefitsThisAcc.length; j++)
            {
                let RoomBenefitsPanel = document.createElement("div");
                RoomBenefitsPanel.className = "RoomBenefitsPanel swiper-slide";
                RoomBenefitsPanel.innerHTML = GetBenefitsThisAcc[j]["benefit_name_" + window.CurrentCountryID];
                RoomHotelBenefitsSwiper.append(RoomBenefitsPanel);
            }

            let RoomBenefitSwiper = new window.Swiper(RoomHotelBenefitsInsidePanel,
            {
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true,
                observer: true,
                observeParents: true,
                autoplay: {
                    delay: 5000,
                },
            });
        }

        let RoomHotelDescToDisplay = window.FinalFilteredAccommodationData[i].hotel_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
        RoomHotelDescToDisplay = window.decodeGarbledContent(RoomHotelDescToDisplay);

        let RoomHotelDescriptionInsidePanel = document.createElement("p");
        RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomHotelDescriptionInsidePanel.innerHTML = RoomHotelDescToDisplay;
        RoomHotelPanelInfoLeftWrapper.append(RoomHotelDescriptionInsidePanel);

        let RoomHotelDisplayedNameInsidePanel = document.createElement("div");
        RoomHotelDisplayedNameInsidePanel.className = "RoomHotelDisplayedNameInsidePanel";
        RoomHotelPanelInfoLeftWrapper.append(RoomHotelDisplayedNameInsidePanel);

        let RoomHotelBedIcon = document.createElement("img");
        RoomHotelBedIcon.src = "/Assets/images/ButtonIcon/bed-bold.svg";
        RoomHotelDisplayedNameInsidePanel.append(RoomHotelBedIcon);

        let RoomHotelRoomName = document.createElement("p");
        RoomHotelRoomName.className = "InterBoldTextFont";
        RoomHotelRoomName.innerHTML = "------";
        if(window.FinalFilteredAccommodationData[i].range_price_room.from_room_name != null)
        {
            RoomHotelRoomName.innerHTML = window.FinalFilteredAccommodationData[i].range_price_room.from_room_name;
        }
        RoomHotelDisplayedNameInsidePanel.append(RoomHotelRoomName);


        let RoomHotelPanelInfoRightWrapper = document.createElement("div");
        RoomHotelPanelInfoRightWrapper.className = "RoomHotelPanelInfoRightWrapper";
        RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoRightWrapper);

        let RoomBottomInfoLeft = document.createElement("div");
        RoomBottomInfoLeft.className = "RoomBottomInfoLeft";
        RoomHotelPanelInfoRightWrapper.append(RoomBottomInfoLeft);

        // let PingToGoWithImgWrapper = document.createElement("div");
        // PingToGoWithImgWrapper.className = "PingToGoWithImgWrapper";
        // PingToGoWithImgWrapper.style.marginLeft = "auto";
        // RoomBottomInfoLeft.append(PingToGoWithImgWrapper);

        // let PingToGoIconInsidePanel = document.createElement("img");
        // PingToGoIconInsidePanel.className = "PingToGoIconInsidePanel";
        // PingToGoIconInsidePanel.src = "/Assets/images/ButtonIcon/warning-circle-blue.svg";
        // PingToGoWithImgWrapper.append(PingToGoIconInsidePanel);

        // let PingToGoInsidePanel = document.createElement("p");
        // PingToGoInsidePanel.className = "PingToGoInsidePanel InterBoldTextFont";
        // PingToGoInsidePanel.style.color = "#2494D9";
        // PingToGoInsidePanel.innerHTML = "Last Ping! -- Hours Ago";
        // PingToGoWithImgWrapper.append(PingToGoInsidePanel);

        // if(window.FinalFilteredAccommodationData[i].last_ping != null) // Last Ping!!
        // {

        //     PingToGoInsidePanel.innerHTML = "Last Ping! " + parseInt(window.FinalFilteredAccommodationData[i].last_ping) + " Hours Ago";
        //     if(window.FinalFilteredAccommodationData[i].last_ping <= 1)
        //     {
        //         PingToGoInsidePanel.innerHTML = "Last Ping! " + parseInt(window.FinalFilteredAccommodationData[i].last_ping) + " Hour Ago";
        //     }
        // }


        // let PingToGo2InsidePanel = document.createElement("p");
        // PingToGo2InsidePanel.className = "PingToGo2InsidePanel InterRegularTextFont";
        // PingToGo2InsidePanel.innerHTML = "-- Ping! to go";
        // RoomBottomInfoLeft.append(PingToGo2InsidePanel);

        // if(window.FinalFilteredAccommodationData[i].ping != null) // Ping To Go
        // {
        //     PingToGo2InsidePanel.innerHTML = parseInt(window.FinalFilteredAccommodationData[i].ping) + " Ping! to go";
        // }


        // let MaxPingToDiscountText = document.createElement("p");
        // MaxPingToDiscountText.className = "PingToGoInsidePanel PingToGo3InsidePanel InterBoldTextFont";
        // MaxPingToDiscountText.innerHTML = "-- Ping to max discount";
        // RoomBottomInfoLeft.append(MaxPingToDiscountText);

        // if(window.FinalFilteredAccommodationData[i].max_ping != null) // Max Ping
        // {
        //     MaxPingToDiscountText.innerHTML = parseInt(window.FinalFilteredAccommodationData[i].max_ping) + " Ping to max discount";
        // }


        let RoomBottomInfoRight = document.createElement("div");
        RoomBottomInfoRight.className = "RoomBottomInfoRight";
        RoomHotelPanelInfoRightWrapper.append(RoomBottomInfoRight);

        if(window.FinalFilteredAccommodationData[i].pick_room != null && window.FinalFilteredAccommodationData[i].range_price_room.from != window.FinalFilteredAccommodationData[i].pick_room.price_after_disc && window.FinalFilteredAccommodationData[i].range_price_room.from != null)
        {
            let CuttedPriceText = document.createElement("p");
            CuttedPriceText.className = "CuttedPriceText InterRegularTextFont";
            CuttedPriceText.innerHTML = parseInt(window.FinalFilteredAccommodationData[i].range_price_room.from);
            RoomBottomInfoRight.append(CuttedPriceText);
        }


        let OriginalPriceText = document.createElement("p");
        OriginalPriceText.className = "OriginalPriceText InterBoldTextFont";
        OriginalPriceText.style.marginLeft = "auto";
        OriginalPriceText.innerHTML = "Rp ------";
        if(window.FinalFilteredAccommodationData[i].pick_room != null && window.FinalFilteredAccommodationData[i].pick_room.price_after_disc != null)
        {
            OriginalPriceText.innerHTML = window.ConvertTextToRP(parseInt(window.FinalFilteredAccommodationData[i].pick_room.price_after_disc), 1, false, false);
        }
        RoomBottomInfoRight.append(OriginalPriceText);

        let PingNightTextInsidePanel = document.createElement("p");
        PingNightTextInsidePanel.className = "PingNightTextInsidePanel InterRegularTextFont";
        PingNightTextInsidePanel.style.marginTop = 0;
        PingNightTextInsidePanel.style.marginRight = 0;
        PingNightTextInsidePanel.innerHTML = "1 " + window["NightTxt" + window.CurrentCountryID];
        RoomBottomInfoRight.append(PingNightTextInsidePanel);

        let RoomPanelDiscountBack;

        if(window.FinalFilteredAccommodationData[i].max_disc != 0)
        {
            // RoomPanelDiscountBack = document.createElement("div");
            // RoomPanelDiscountBack.className = "RoomPanelDiscountBack";
            // RoomHotelPanel.append(RoomPanelDiscountBack);

            // let RoomPanelDiscountTop = document.createElement("div");
            // RoomPanelDiscountTop.className = "RoomPanelDiscountTop";
            // RoomPanelDiscountBack.append(RoomPanelDiscountTop);

            // let RoomPanelDiscountTopCorner = document.createElement("div");
            // RoomPanelDiscountTopCorner.className = "RoomPanelDiscountTopCorner";
            // RoomPanelDiscountTop.append(RoomPanelDiscountTopCorner);

            // let RoomPanelDiscountTopValue = document.createElement("p");
            // RoomPanelDiscountTopValue.className = "RoomPanelDiscountTopValue InterBoldTextFont";
            // RoomPanelDiscountTopValue.innerHTML = parseInt(window.FinalFilteredAccommodationData[i].max_discount) + "% Max";
            // RoomPanelDiscountTop.append(RoomPanelDiscountTopValue);

            RoomPanelDiscountBack = document.createElement("div"); // Discount Top Max
            RoomPanelDiscountBack.className = "RoomPanelDiscountBackNew";
            RoomHotelPanel.append(RoomPanelDiscountBack);

            let RoomPanelDiscountTopNew = document.createElement("div");
            RoomPanelDiscountTopNew.className = "RoomPanelDiscountTopNew";
            RoomPanelDiscountBack.append(RoomPanelDiscountTopNew);

            let RedBannerNew = document.createElement("img");
            RedBannerNew.className = "RedBannerNew";
            RedBannerNew.src = "/Assets/images/Icon/red-barner-new.png";
            RoomPanelDiscountTopNew.append(RedBannerNew);

            let RoomPanelDiscountTopValueNew = document.createElement("p");
            RoomPanelDiscountTopValueNew.className = "RoomPanelDiscountTopValue InterBoldTextFont";
            RoomPanelDiscountTopValueNew.innerHTML = parseInt(window.FinalFilteredAccommodationData[i].max_disc) + "%";
            RoomPanelDiscountTopNew.append(RoomPanelDiscountTopValueNew);
        }

        // ------------------------------- ROOM UNAVAILABLE -----------------------------

        let CurrentUrl = new URL(window.location.href);
        let HREFUrl = "/" + window.FinalFilteredAccommodationData[i].category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" + window.FinalFilteredAccommodationData[i].id_hotel + ".html?search=" + CurrentUrl.searchParams.get("search") + "&checkin=" +CurrentUrl.searchParams.get("checkin") + "&checkout=" + CurrentUrl.searchParams.get("checkout") + "&room=" + CurrentUrl.searchParams.get("room");
        
        if(window.FinalFilteredAccommodationData[i].pick_room == null && window.FinalFilteredAccommodationData[i].status_available == "No")
        {
            let RoomUnavailableBlockerHotelDetails = document.createElement("div");
            RoomUnavailableBlockerHotelDetails.className = "RoomUnavailableBlockerHotelDetails";
            RoomUnavailableBlockerHotelDetails.style.zIndex = 1;
            RoomHotelWrapper.append(RoomUnavailableBlockerHotelDetails);

            let RoomUnavailableWrapper = document.createElement("div");
            RoomUnavailableWrapper.className = "RoomUnavailableWrapper";
            RoomUnavailableBlockerHotelDetails.append(RoomUnavailableWrapper);

            let RoomUnavailableHeaderText = document.createElement("p");
            RoomUnavailableHeaderText.className = "RoomUnavailableHeaderText RoomUnavailableText InterBoldTextFont";
            RoomUnavailableHeaderText.innerHTML = window["RoomUnavailableTxt" + window.CurrentCountryID];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderText);

            let RoomUnavailableHeaderMessage = document.createElement("p");
            RoomUnavailableHeaderMessage.className = "RoomUnavailableHeaderMessage RoomUnavailableText InterMediumTextFont";
            RoomUnavailableHeaderMessage.innerHTML = window["RoomUnavailableWithCurrentSetTxt" + window.CurrentCountryID];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderMessage);

            let GotoHotelButton = document.createElement("button");
            GotoHotelButton.className = "BasicTextButton BasicBoxShadow OrangeButton LoadMoreButton Selectable";
            GotoHotelButton.innerHTML = window["GoToAccommodationTxt" + window.CurrentCountryID];
            RoomUnavailableWrapper.append(GotoHotelButton);

            let GotoHotelButtonHref = document.createElement("a");
            GotoHotelButtonHref.className = "HREFInsideContainer";
            GotoHotelButtonHref.href = HREFUrl;
            GotoHotelButton.append(GotoHotelButtonHref);

            if(RoomPanelDiscountBack != null)
            RoomPanelDiscountBack.remove();
        }
        else
        {
            // ------------------------------- HREF BUTTON ---------------------------------

            let MyPingButtonHREF = document.createElement("a")
            MyPingButtonHREF.className = "HREFInsideContainer";
            MyPingButtonHREF.href = HREFUrl;
            RoomHotelPanel.append(MyPingButtonHREF);

            // ------------------------------------------------------------------------------
        }

        // Not Available------
        // if(SortedJSON[(i+TotalShown)].max_ping == null && SortedJSON[(i+TotalShown)].min_price == null)
        // {

        // }
    }
}


// ======================= FILTER BUTTON CLICKED =============================

window.ShowFilterMenuLeftClicked = function()
{
    let FilterleftPanel = document.getElementById("FilterleftPanel");

    if(FilterleftPanel.classList.contains("FilterleftPanelOpen") == false)
    {
        document.getElementById("FilterBlocker").style.display = "";
        FilterleftPanel.classList.add("FilterleftPanelOpen");
    }
    else
    {
        document.getElementById("FilterBlocker").style.display = "none";
        FilterleftPanel.classList.remove("FilterleftPanelOpen");
    }
}

// ====================== CHANGE SORT BUTTON CENTER ================================

window.SortButtonClicked = function(thistypename)
{
    let SortButtons = document.querySelectorAll('.SortTopButton');
    let OrangeBackAnimate = document.getElementById("SelectedSortOrangeWrapper");
    window.CurrentSort = thistypename;
    for(let i = 0; i < SortButtons.length; i++)
    {
        if((thistypename + "SortButton") == SortButtons[i].id)
        {
            SortButtons[i].className = "SortTopButton SortTopButtonSelected Selectable2";
            OrangeBackAnimate.style.left = (25 * i )+"%";
        }
        else
        {
            SortButtons[i].className = "SortTopButton Selectable2";
        }
    }

    // Reset Data ---------------------------------------------------------

    window.CurrentPage = 0;
    window.SortedAccommodationData = [];
    window.SearchPaginationData = null;

    let WhereToInstantiate = document.getElementById("SearchResultPanelContainer");
    WhereToInstantiate.innerHTML = "";

    // Set Observer and Load Accommodation ------------------------------------------------

    window.searchobserver.observe(window.ScrollSentinel);
}


// ======================= GET SORT ON THE LEFT ===============================

window.PrepareBenefitFilter = function(BenefitsGetData)
{
    let PopularFilterMainContainer = document.getElementById("PopularFilterMainContainer");
    let LeftPopularFilterContainer = document.getElementById("LeftPopularFilterContainer");
    PopularFilterMainContainer.style.display = "none";

    let ListOfBenefits = [];
    let ListOfBenefitsID = [];

    if(BenefitsGetData.length != 0)
    {
        for(let i = 0; i < BenefitsGetData.length; i++)
        {
            ListOfBenefits.push(BenefitsGetData[i]["benefit_name_" + window.CurrentCountryID]);
            ListOfBenefitsID.push(BenefitsGetData[i].id_benefit);
        }

        PopularFilterMainContainer.style.display = "";
        LeftPopularFilterContainer.innerHTML = "";

        window.InstantiateCheckBox(ListOfBenefits, ListOfBenefitsID, LeftPopularFilterContainer, 'PopularFilterCheckBox');
    }
}

window.PrepareCityRegionCheckBox = function(CityRegionData)
{
    let AreaFilterMainContainer = document.getElementById("AreaFilterMainContainer");
    let LeftAreaFilterContainer = document.getElementById("LeftAreaFilterContainer");
    AreaFilterMainContainer.style.display = "none";

    // Prepare Sort Info ----------------------------------

    let GetCityRegionList = [];
    let GetCityRegionSlugList = [];

    if(CityRegionData.length > 0)
    {
        for(let i = 0; i < CityRegionData.length; i++)
        {
            if(GetCityRegionList.includes(CityRegionData[i].city_region) == false)
            {
                GetCityRegionList.push(CityRegionData[i].city_region);
                GetCityRegionSlugList.push(CityRegionData[i].city_region_slug);
            }
        }

        AreaFilterMainContainer.style.display = "";
        LeftAreaFilterContainer.innerHTML = "";

        // Instantiate Check Box ----------------------------------

        window.InstantiateCheckBox(GetCityRegionList, GetCityRegionSlugList, LeftAreaFilterContainer, 'AreaFilterCheckBox');

        // If Area (City Region) Exist in URL Immediately Check It ----------------------------------

        let CurrentUrl = new URL(window.location.href);
        if(CurrentUrl.searchParams.has('area'))
        {
            let SelectedAreaSet = CurrentUrl.searchParams.get("area");
            let SortButtons = document.querySelectorAll('.AreaFilterCheckBox');
            //console.log(SelectedAreaSet + " --------------");
            SortButtons.forEach(SortButton =>
            {
                if(SortButton.getAttribute("display-name") == SelectedAreaSet)
                {
                    SortButton.checked = true;
                }
            });
        }

        // Apply Changes -----------------------

        window.SortButtonClicked(window.CurrentSort); // Change Sort Button --------------
    }
}

window.GetTheCategorySortCheck = function(CategoryData)
{
    let CategoryFilterMainContainer = document.getElementById("CategoryFilterMainContainer");
    let LeftCategoryFilterContainer = document.getElementById("LeftCategoryFilterContainer");
    CategoryFilterMainContainer.style.display = "none";

    let GetCategoryList = [];
    let GetCategoryListID = [];

    if(CategoryData.length > 0)
    {
        for(let i = 0; i < CategoryData.length; i++)
        {
            GetCategoryList.push(CategoryData[i].category_name);
            GetCategoryListID.push(CategoryData[i].id_category);
        }

        //---------------------------- REMOVE ALL EXISTING AREA CHECK BOX ------------------------------

        CategoryFilterMainContainer.style.display = "";
        LeftCategoryFilterContainer.innerHTML = "";

        window.InstantiateCheckBox(GetCategoryList, GetCategoryListID, LeftCategoryFilterContainer, 'CategoryFilterCheckBox');
    }
}


// =================================== INSTANTIATE CHECK BOX ===================================

window.InstantiateCheckBox = function(ListOfSortData, ListOfSlugData, wheretoInstantiate, ClassNameCheckBox)
{
    for(let i = 0; i < ListOfSortData.length; i++)
    {
        let PopularFilterPanel = document.createElement("div");
        PopularFilterPanel.className = "PopularFilterPanel";
        wheretoInstantiate.append(PopularFilterPanel);

        let FilterCheckBoxContainer = document.createElement("label");
        FilterCheckBoxContainer.className = "FilterCheckBoxContainer";
        PopularFilterPanel.append(FilterCheckBoxContainer);

        let popularfilter = document.createElement("input");
        popularfilter.type = "checkbox";
        popularfilter.name = "popularfilter";
        popularfilter.className = "FilterCheckBox Selectable " + ClassNameCheckBox;
        popularfilter.value = ListOfSlugData[i];
        popularfilter.setAttribute("display-name", ListOfSortData[i]);
        popularfilter.onchange = function()
        {
            window.SortButtonClicked(window.CurrentSort);
        }
        FilterCheckBoxContainer.append(popularfilter);

        let CheckBoxSpan = document.createElement("span");
        CheckBoxSpan.className = "CheckBoxSpan";
        FilterCheckBoxContainer.append(CheckBoxSpan);

        let CheckBoxText = document.createElement("p");
        CheckBoxText.className = "CheckBoxText InterMediumTextFont";
        CheckBoxText.innerHTML = ListOfSortData[i];
        PopularFilterPanel.append(CheckBoxText);
    }
}

// =================== SCROLL OBSERVER ==============================

window.searchobserver = new IntersectionObserver
(
    (entries) =>
    {
        if(entries[0].isIntersecting)
        {
            if(window.SearchPaginationData == null ||
            (window.SearchPaginationData != null && window.SearchPaginationData.has_more == true)
            )
            {
                window.CurrentPage = window.CurrentPage + 1;
                window.LoadAccommodationBasedOnSort();
            }
            else
            {
                window.searchobserver.disconnect();
            }
        }
    },
    {
        root: null,        // viewport
        threshold: 0.1     // trigger slightly before full reach
    }
);